import axios from 'axios';

// Global response interceptor: redirect to login on 401 (expired/invalid token)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      window.location.pathname !== '/login'
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('userID');
      window.location.href = '/login';
      // Return a never-resolving promise to stop the calling code
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
